import React, { useEffect } from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { ClerkProvider, useAuth } from "@clerk/react"
import App from "./App"
import { initObservability } from "./lib/observability"
import { registerServiceWorker } from "./lib/sw-register"
import { setClerkTokenGetter } from "./lib/api-client"
import { isDoctorHost } from "./lib/host"
import "./index.css"

// VITE_ prefix exposes these at build time. Both keys are embedded in the
// bundle; runtime selection via isDoctorHost() picks the right one.
const CLERK_CLINIC_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined
// Publishable key is intentionally hardcoded as fallback — it is public by design.
// Coolify build workspace may have a stale .env.local that overrides the build-arg.
const CLERK_D2C_KEY    = (import.meta.env.VITE_CLERK_D2C_PUBLISHABLE_KEY as string | undefined)?.startsWith("pk_live_")
  ? import.meta.env.VITE_CLERK_D2C_PUBLISHABLE_KEY as string
  : "pk_live_Y2xlcmsuc25vd21lZC5oZWFsdGgk"

initObservability()
registerServiceWorker()

// Registers the Clerk getToken function with apiFetch so every API call
// automatically includes the current Clerk session token as a Bearer header.
function ClerkTokenSync() {
  const { isLoaded, getToken } = useAuth()
  useEffect(() => {
    if (isLoaded) {
      setClerkTokenGetter(() => getToken())
    } else {
      setClerkTokenGetter(null)
    }
  }, [isLoaded, getToken])
  return null
}

const publishableKey = isDoctorHost() ? (CLERK_D2C_KEY ?? "") : (CLERK_CLINIC_KEY ?? "")

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={publishableKey}>
      <ClerkTokenSync />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </React.StrictMode>
)
